/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, useHistory, Link, useLocation } from "react-router-dom";
import Axios from "axios";
// Material UI
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { TextField, Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
// Pages
import StateContext from "../StateContext";
import GoSellElementsTrans from "./GoSellv1";
import DispatchContext from "../DispatchContext";
import Invoice from "./Invoice";
import Navbar from "../Components/Navbar";
import LoginModal from "../Components/loginModal/loginModal";
import SaveCardsModal from "../Components/saveCardsModal/saveCardsModal";
import CustomizedDialogs from "../Components/CustomizedDialogs";
import MiscBanner from "../Components/MiscBanner";
import MiscBannerv2 from "../Components/MiscBannerv2/MiscBannerv2";
import MiscBannerv3 from "../Components/MiscBannerv3/MiscBannerv3";
import LoaderAnimation from "../Components/LoaderAnimation";
import LoginDialog from "../Components/LoginDialog";
import useMediaQuery from "@mui/material/useMediaQuery";
// import InvoiceDesktop from "../Components/InvoiceDesktop";
// import InvoiceReadyPayment from "../Components/InvoiceReadyPayment";
import { styled } from "@mui/system";
// import TabsUnstyled from "@mui/base/TabsUnstyled";
// import TabsListUnstyled from "@mui/base/TabsListUnstyled";
// import { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";


import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import knetsm from "../Assets/images/knet.png";
import masterVisa from "../Assets/images/masterVisa.png";
import simpleCash from "../Assets/images/simpleCash.png";
import Backdrop from "@mui/material/Backdrop";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { get_lang } from "../Functions/getLang";
// Cookies functions
import { getCookie, setCookie, erase } from "../Functions/cookieFunction";
import { ta } from "date-fns/locale";
import NotFound from "./NotFound/NotFound";
import PartialInvoice from "./PartialInvoice";
import SplitBillOptions from "../Components/splitBillOptions/splitBillOptions";
import PayForItems from "../Components/payForItems/payForItems";
import DivideBill from "../Components/divideBill/divideBill";
import PayCustomAmount from "../Components/payCustomAmount/payCustomAmount";
import ShareInvoiceQrcode from "../Components/shareInvoiceQrcode/shareInvoiceQrcode";
import SplitBillDetails from "../Components/splitBillDetails/splitBillDetails";
import SwipeableEdgeDrawer from "../Components/Dumy";
import ApplePayBtn from "../Components/applePayButton/applePayButton";
import { getApplePayToken } from "../helper/applePay";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { handleError } from "../Functions/getAlert";
import RewardPunchPopup from "../Components/rewardPunchPopup/rewardPunchPopup";
import vendorsConfig from "../vendorsConfig";
import { formatMoney, getCurrencyLabel, normalizeCurrencyCode } from "../helper/customeObj";
import RestaurantInvoicePaymentOneScreen from "./RestaurantInvoicePaymentOneScreen";
import InvoiceDesign from "./InvoiceDesign/InvoiceDesign";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  height: {
    height: "100vh",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
    width: "100%",
  },

  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const blue = {
  50: "#F0F7FF",
  100: "#C2E0FF",
  200: "#80BFFF",
  300: "#66B2FF",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  700: "#0059B2",
  800: "#004C99",
  900: "#003A75",
};
// const Tab = styled(TabUnstyled)`
//   font-family: IBM Plex Sans, sans-serif;
//   color: white;
//   cursor: pointer;
//   font-size: 0.875rem;
//   font-weight: bold;
//   background-color: transparent;
//   width: 100%;
//   padding: 12px 12px;
//   margin: 6px 6px;
//   border: none;
//   border-radius: 5px;
//   display: flex;
//   justify-content: center;
//   flex-direction: column;
//   align-items: center;

//   &:hover {
//     background-color: ${blue[400]};
//   }

//   &:focus {
//     color: #fff;
//     border-radius: 3px;
//     outline: 2px solid ${blue[200]};
//     outline-offset: 2px;
//   }

//   &.${tabUnstyledClasses.selected} {
//     background-color: ${blue[50]};
//     color: ${blue[600]};
//   }

//   &.${buttonUnstyledClasses.disabled} {
//     opacity: 0.5;
//     cursor: not-allowed;
//   }
// `;

// const TabsList = styled(TabsListUnstyled)`
//   min-width: 320px;
//   background-color: ${blue[500]};
//   border-radius: 8px;
//   margin-bottom: 16px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   align-content: space-between;
// `;
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const Payment = () => {
  const appState = useContext(StateContext);
  const { t } = useTranslation();
  const appDispatch = useContext(DispatchContext);
  const [payWithValue, setPayWithValue] = useState("");
  const [paymentSource, setPaymentSource] = useState("");
  const { invoiceType, id } = useParams();
  const [type, setType] = useState(null);
  const [invoiceDetails, setInvoiceDetails] = useState("");
  // console.log(invoiceDetails)
  const [partialInvoice, setPartialInvoice] = useState([]);
  const [orders, setOrders] = useState([]);
  const [combos, setCombos] = useState([]);
  const [metaOrders, setMetaOrders] = useState([]);
  const classes = useStyles();
  const childRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [field, setField] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);
  const [pLoading, setPLoading] = useState(false);
  // const [cardResponse, setCardResponse] = useState([])
  const [tapId, setTapId] = useState(null);
  const [tapCardDetails, setTapCardDetails] = useState(null);
  const [cardStatus, setCardStatus] = useState("");
  const [success, setSuccess] = useState(false);
  const history = useHistory();
  const [amount, setAmount] = useState(0);
  const { search, pathname } = useLocation();
  const searchParams = new URLSearchParams(search);
  const hasDelivery = pathname.includes('delivery');
  const hasPickup = pathname.includes('pickup');

  useEffect(() => {
    if (hasDelivery|| hasPickup) {
      setType("in")
    } else {
      setType(invoiceType)
    }
  }, [hasDelivery, hasPickup, invoiceType])

  useEffect(() => {
    let isRedirect = !pathname.includes('delivery') && invoiceDetails?.invoiceable?.service_type == "Delivery" ? true : false
    if (isRedirect) {

      history.push(`/delivery/${invoiceDetails?.id}`);
    }
  }, [invoiceDetails])



  const [customer, setCustomer] = useState({});
  const [tryAgain, setTryAgain] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });
  const [store, setStore] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState(false);
  const [formData, setFormData] = useState({
    number: "",
  });
  const [invoiceFound, setInvoiceFound] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPartialInvoice, setShowPartialInvoice] = useState(false);
  const [splitBillAmount, setSplitBillAmount] = useState(0);
  const [personWillPay, setPersonWillPay] = useState(1);
  const [totalPerson, setTotalPerson] = useState(2);
  const [partialType, setPartialType] = useState(null);
  const [paySelectedItems, setPaySelectedItems] = useState([]);
  const ApplePaySession = window.ApplePaySession;
  const [addsInfo, setAddsInfo] = useState(null)
  const [storeBranchId, setStoreBranchId] = useState(0)
  const [eventOrder, setEventOrder] = useState(false)

  useEffect(() => {
    if (appState.profile) {
      setField({
        ...field,
        name: appState.profile.name,
        email: appState.profile.email,
        mobile_no: appState.profile.number,
      });
    }
  }, [appState.profile]);

  const handlePaymentChange = (event) => {
    let updatedValue =  event == payWithValue ?  '' :  event;
    setPayWithValue(updatedValue);
    if (updatedValue !== "card") {
      setTapCardDetails(null);
      setTapId(null);
    }
  };
  const showInvoice = (id) => {
    window.open(window.location.href + `?partial=` + id, "_blank");
  };

  const handleRemaningAmount = () => {
    return (amount?.toFixed(3) - invoiceDetails?.amount?.toFixed(3)) - splitBillAmount
  }

  const removeLocalStorage = () => {
    setPayWithValue("");
    setSplitBillAmount(0);
    setPersonWillPay(1);
    setTotalPerson(2);
    setPartialType(null);
    setPaySelectedItems([]);

    localStorage.removeItem("selectedItems");
    localStorage.removeItem("divideColor");

    localStorage.removeItem("divideBill");
    localStorage.removeItem("payForItem");
    localStorage.removeItem("splitBillOptions");
    localStorage.removeItem("splitBill");
    localStorage.removeItem("splitBill");
  };

  const payInvoices = async () => {
    appDispatch({
      type: "Set_FreezScreen",
      freezScreen: true,
    });
    if (type == "qp") {
      if (
        payWithValue == "wallet" ||
        payWithValue == "knet" ||
        payWithValue == "card"
      ) {
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}order_invoice/offline`,
            {
              country_code: "965",
              number: appState.loggedIn
                ? appState.profile.number
                : formData.number,
              name: appState.loggedIn
                ? appState.profile.userFirstName
                : customer.name
                  ? customer.name
                  : formData.name
                    ? formData.name
                    : `Customer${Date.now()}`,
              email:
                appState.loggedIn && appState.profile.email != null
                  ? appState.profile.email
                  : formData.email != undefined
                    ? formData.email
                    : null,
              store_slug: id,
              customer_id: appState.loggedIn ? appState.profile.customerId : "",
              amount: amount,
              payment_source: payWithValue ? payWithValue : null,
              token: tapId ? tapId : null,
              card_details: tapCardDetails ? tapCardDetails : null,
            }
          );
          if (response.data.success == true) {
            const win = window.open(`${response.data.data.url}`, "_self");
            win.focus();
            localStorage.removeItem("formData");
            localStorage.removeItem("fields");
            setTapId(null);
            setTapCardDetails(null);
          } else if (response.data.success == false) {
            setAlertMessage({
              open: true,
              message: `${response.data.message}: ${response.data.data}`,
              alertSuccess: false,
            });
            appDispatch({
              type: "Set_FreezScreen",
              freezScreen: false,
            });

            setPLoading(false);
          }
        } catch (e) {
          handleError(e, appDispatch);
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
      } else {
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}order_invoice/offline`,
            {
              country_code: "965",
              number: appState.loggedIn
                ? appState.profile.number
                : formData.number,
              name: appState.loggedIn
                ? appState.profile.userFirstName
                : customer.name
                  ? customer.name
                  : formData.name
                    ? formData.name
                    : `Customer${Date.now()}`,
              email:
                appState.loggedIn && appState.profile.email != null
                  ? appState.profile.email
                  : formData.email != undefined
                    ? formData.email
                    : null,
              store_slug: id,
              customer_id: appState.loggedIn ? appState.profile.customerId : "",
              amount: amount,
              payment_source: "save_card",
              card_id: payWithValue,
              save_card: false,
              card_details: tapCardDetails ? tapCardDetails : null,
            }
          );
          if (response.data.success == true) {
            const win = window.open(`${response.data.data.url}`, "_self");
            win.focus();
            localStorage.removeItem("formData");
            localStorage.removeItem("fields");
            setTapId(null);
            setTapCardDetails(null);
          } else if (response.data.success == false) {
            setAlertMessage({
              open: true,
              message: `${response.data.message}: ${response.data.data}`,
              alertSuccess: false,
            });
            appDispatch({
              type: "Set_FreezScreen",
              freezScreen: false,
            });

            setPLoading(false);
          }
        } catch (e) {
          handleError(e, appDispatch);
          setPLoading(false);
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
      }
    } else if (type == "in" && !invoiceDetails?.is_partial) {
      if (
        payWithValue == "wallet" ||
        payWithValue == "knet" ||
        payWithValue == "card"
      ) {
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}order_invoice/pay`,
            {
              country_code: "965",
              number: appState.loggedIn
                ? appState.profile.number
                : formData.number,
              name: appState.loggedIn
                ? appState.profile.userFirstName
                : formData.name
                  ? formData.name
                  : null,
              email:
                appState.loggedIn && appState.profile.email != null
                  ? appState.profile.email
                  : formData.email != undefined
                    ? formData.email
                    : null,
              customer_id: appState.loggedIn
                ? appState.profile.customerId
                : null,
              invoice_id: id,
              amount: amount,
              payment_source: payWithValue ? payWithValue : null,
              token: tapId ? tapId : null,
              save_card: false,
              card_details: tapCardDetails ? tapCardDetails : null,
            }
          );
          if (response.data.success == true) {
            const win = window.open(`${response.data.data.url}`, "_self");
            win.focus();
            localStorage.removeItem("formData");
            localStorage.removeItem("fields");
            setTapId(null);
            setTapCardDetails(null);
          } else if (response.data.success == false) {
            setAlertMessage({
              open: true,
              message: `${response.data.message}: ${response.data.data}`,
              alertSuccess: false,
            });
            appDispatch({
              type: "Set_FreezScreen",
              freezScreen: false,
            });
          }
        } catch (e) {
          handleError(e, appDispatch);
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
      } else {
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}order_invoice/pay`,
            {
              country_code: "965",
              number: appState.loggedIn
                ? appState.profile.number
                : formData.number,
              name: appState.loggedIn
                ? appState.profile.userFirstName
                : formData.name
                  ? formData.name
                  : `Customer${Date.now()}`,
              email:
                appState.loggedIn && appState.profile.email != null
                  ? appState.profile.email
                  : formData.email != undefined
                    ? formData.email
                    : null,
              invoice_id: id,
              amount: amount,
              payment_source: "save_card",
              card_id: payWithValue,
              customer_id: appState.loggedIn ? appState.profile.customerId : "",
              save_card: false,
              card_details: tapCardDetails ? tapCardDetails : null,
            }
          );
          if (response.data.success == true) {
            const win = window.open(`${response.data.data.url}`, "_self");
            win.focus();
            localStorage.removeItem("formData");
            localStorage.removeItem("fields");
            setTapId(null);
            setTapCardDetails(null);
          } else if (response.data.success == false) {
            setAlertMessage({
              open: true,
              message: `${response.data.message}: ${response.data.data}`,
              alertSuccess: false,
            });
            appDispatch({
              type: "Set_FreezScreen",
              freezScreen: false,
            });
          }
        } catch (e) {
          handleError(e, appDispatch);
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
      }
    } else if (type == "in" && invoiceDetails?.is_partial) {
      if (splitBillAmount <= amount) {
        if (
          payWithValue == "wallet" ||
          payWithValue == "knet" ||
          payWithValue == "card"
        ) {
          try {
            const response = await Axios.post(
              `${process.env.REACT_APP_API_URL}partial_invoice/pay`,
              {
                save_card: false,
                country_code: "965",
                number: appState.loggedIn
                  ? appState.profile.number
                  : formData.number,
                name: appState.loggedIn
                  ? appState.profile.userFirstName
                  : formData.name
                    ? formData.name
                    : `Customer${Date.now()}`,
                email:
                  appState.loggedIn && appState.profile.email != null
                    ? appState.profile.email
                    : formData.email != undefined
                      ? formData.email
                        : null,
                customer_id: appState.loggedIn
                  ? appState.profile.customerId
                  : "",
                invoice_id: id,
                amount: handleRemaningAmount() <= 0.1 
                ? (Number(splitBillAmount) + Number(handleRemaningAmount())).toFixed(3) 
                : Number(splitBillAmount).toFixed(3),
                // payment_source: null,
                payment_source: payWithValue ? payWithValue : null,
                token: tapId ? tapId : null,
                card_details: tapCardDetails ? tapCardDetails : null,
                type: partialType,
                meta: {
                  data:
                    partialType == "ratio"
                      ? {
                        person: totalPerson,
                        payer: personWillPay,
                      }
                      : partialType == "product"
                        ? paySelectedItems
                        : null,
                  partial_type: partialType,
                },
                card_details: tapCardDetails ? tapCardDetails : null,
              }
            );
            if (response.data.success == true) {
              const win = window.open(`${response.data.data.url}`, "_self");
              win.focus();
              localStorage.removeItem("formData");
              localStorage.removeItem("fields");
              setTapId(null);
              setTapCardDetails(null);
              removeLocalStorage();
            } else if (response.data.success == false) {
              setAlertMessage({
                open: true,
                message: `${response.data.message}: ${response.data.data}`,
                alertSuccess: false,
              });
              appDispatch({
                type: "Set_FreezScreen",
                freezScreen: false,
              });
            }
          } catch (e) {
            erase("tokenAuth");
            erase("Profile");
            appDispatch({ type: "logout" });
            handleError(e, appDispatch);
            appDispatch({
              type: "Set_FreezScreen",
              freezScreen: false, 
            });
          }
        } else {

          try {
            const response = await Axios.post(
              `${process.env.REACT_APP_API_URL}order_invoice/pay`,
              {
                save_card: false,

                country_code: "965",
                number: appState.loggedIn
                  ? appState.profile.number
                  : formData.number,
                name: appState.loggedIn
                  ? appState.profile.userFirstName
                  : formData.name
                    ? formData.name
                    : `Customer${Date.now()}`,
                email:
                  appState.loggedIn && appState.profile.email != null
                    ? appState.profile.email
                    : formData.email != undefined
                      ? formData.email
                      : null,
                invoice_id: id,
                amount: amount,
                // payment_source: "save_card",
                payment_source: null,
                card_id: payWithValue,
                customer_id: appState.loggedIn
                  ? appState.profile.customerId
                  : "",
                card_details: tapCardDetails ? tapCardDetails : null,
              }
            );
            if (response.data.success == true) {
              const win = window.open(`${response.data.data.url}`, "_self");
              win.focus();
              localStorage.removeItem("formData");
              localStorage.removeItem("fields");
              setTapId(null);
              setTapCardDetails(null);
              removeLocalStorage();
            } else if (response.data.success == false) {
              setAlertMessage({
                open: true,
                message: `${response.data.message}: ${response.data.data}`,
                alertSuccess: false,
              });
              appDispatch({
                type: "Set_FreezScreen",
                freezScreen: false,
              });
            }
          } catch (e) {
            handleError(e, appDispatch);

            appDispatch({
              type: "Set_FreezScreen",
              freezScreen: false,
            });
        
        
        
        
        
            erase("tokenAuth");
        erase("Profile");
          appDispatch({ type: "logout" });
          }
        }
      } else {
        setAlertMessage({
          open: true,
          message: " Amount is greater than remaining ",
          alertSuccess: false,
        });
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    }
  };

  const getAdds = async (id) => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_URL}advertising?branch=${id}`
      );
      if (response.data.success) {
        if (response?.data?.data?.length > 0) {
          let adds = response?.data?.data
          let addArr = []
          // for(var i=0; i<4; i++){
          //   addArr.push(adds)
          // }
          setAddsInfo(adds);

        }
      }
    } catch (e) {
    }
  }

  const getStore = async (slug, branchID, branchSlug) => {
    setIsLoading(true);
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_URL}minify/${slug}?branch=${branchID}`
      );
      if (response.data.success) {
        const branchRes = await Axios.get(
          `${process.env.REACT_APP_API_URL}branch/minify/${branchSlug}`
        );
            if(branchRes.data.success){
              let branchData = await branchRes.data.data;
              let storeData = await response.data.data;
              getAdds(branchData?.id)
              let arry = {
                store_id: storeData?.id,
                branch_id: branchData?.id,
                cover: storeData?.business?.cover,
                business_name: get_lang(storeData?.business?.name, appState.langValue),
                business_desc: get_lang(
                  storeData?.store_category?.name,
                  appState.langValue
                ),
                currencyCode: normalizeCurrencyCode(storeData?.business?.currency),
                currency: getCurrencyLabel(storeData?.business?.currency, appState.langValue),
                logo: storeData?.business?.logo,
                key: branchData?.tap_account?.public_key,
                tapKey: branchData?.tap_account?.public_key ?? null,
                payments: branchData?.payments,
                tap: branchData?.tap_account != null ? true : false,
                merchantId: branchData?.tap_account?.merchant_id ?? null,
                ratings: storeData?.ratings ?? [],
                rating_id:storeData?.google_place_id,
                slug:storeData?.slug,
              };
              appDispatch({
                type: "SET_STORE_INFORMATION",
                storeInfo: arry,
              });
              setStore(arry);
            }

      }
      setIsLoading(false);
    } catch (e) {
      handleError(e, appDispatch);
      setIsLoading(false);
      setAlertMessage({
        open: true,
        message: e,
        alertSuccess: false,
      });
    }
  };
  const handleApplePay = () => {
    appDispatch({
      type: "Set_FreezScreen",
      freezScreen: true,
    });
    setPLoading(true);
    let payDAta = {
      formData: formData,
      customer: customer,
      amount: amount,
      payWithValue: payWithValue,
      tapId: tapId,
      id: id,
      type: type,
      invoiceDetails: invoiceDetails,
      partialType: partialType,
      totalPerson: totalPerson,
      personWillPay: personWillPay,
      paySelectedItems: paySelectedItems,
      ApplePaySession: ApplePaySession,
      splitBillAmount: splitBillAmount,
      handleRemaningAmount: handleRemaningAmount()
    };

    getApplePayToken(
      payDAta,
      appState,
      setTapId,
      appDispatch,
      setPLoading,
      setAlertMessage,
      removeLocalStorage
    );
  };

  const handleClickApplePay = () => {
    if (type == "in" && invoiceDetails?.is_partial) {
      if (splitBillAmount <= amount) {
        handleApplePay();
      } else {
        setAlertMessage({
          open: true,
          message: " Amount is greater than remaining ",
          alertSuccess: false,
        });
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    } else {
      handleApplePay();
    }
  };
  const handleSubmit = (event) => {
    
    event.preventDefault();
    localStorage.setItem("formData", JSON.stringify(formData));
    if (payWithValue != undefined && payWithValue != "") {
      if (payWithValue == "card") {
        if (tapId) {
          payInvoices();
        } else {
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
          setButtonLoading(true);
          childRef.current?.submitRequest();
        }
      } else {
        payInvoices();
      }
    } else {
      setAlertMessage({
        open: true,
        message: "Please select any payment method!",
        alertSuccess: false,
      });
      appDispatch({
        type: "Set_FreezScreen",
        freezScreen: false,
      });
    }
  };


  const orderInvoiceIn = async () => {
    setIsLoading(true);
    setShowPartialInvoice(searchParams.has("partial"));

    if (type === "in") {
      try {
        const response = searchParams.get("partial")
          ? await Axios.get(
            `${process.env.REACT_APP_API_URL
            }partial_invoice/${searchParams.get("partial")}`
          )
          : await Axios.get(
            `${process.env.REACT_APP_API_URL}order_invoice/${id}`
          );
        if (response.data.success) {
          var res = response.data.data.invoiceable;
          var branch = response.data.data?.branch;
          let branchID = branch?.id;
          var branchSlug = branch?.slug
          var service = res.service;
          let intRes = res.integration;
          let integrationName = intRes?.integration?.type?.name
          let integrationData = intRes?.data
          if(integrationName == "WIYAK" && intRes?.integration?.active){
          let integration = {
            providerName: intRes?.integration?.type?.name,
            integrationId: intRes?.integration?.type?.id,
            deliveryAmount: integrationData?.amount,
            riderStatus: integrationData?.satus,
            riderName:  integrationData?.driver_info[0]?.name,
            riderNumber: integrationData?.driver_info[0]?.contry_code + integrationData?.driver_info[0]?.phone ,
            estimateDeliveryTime: integrationData?.estimate_timeline[0]?.delivery_date_time,
            vehicleNumber: integrationData?.vehicle_info[0]?.license_plate,
            vehicleBrand: integrationData?.vehicle_info[0]?.brand,
            vehicleColor: integrationData?.vehicle_info[0]?.color,
            bookingId:  integrationData?.display_book_id
          }     
          appDispatch({
            type: "setDeliveryRiderInfo",
            deliveryRiderInfo: integration,
          })
          }
          else{}
          var slug = await response.data.data.business.slug;
          if (!searchParams.has("partial")) {
            setAmount(res?.amount ?? response.data.data?.amount ?? 0);
            setCustomer(response.data.data.customer);
          }
          // else{
          //   console.log(response.data.data);
          //   // setSplitBillAmount()
          // }
          if (response?.data?.data?.is_partial) {
            const paidAmount = response?.data?.data?.amount;
            const totalAmount = res?.amount;
            const remainingAmount = totalAmount - paidAmount
            setSplitBillAmount(remainingAmount)
          }
          if (res?.service_type == "OrderEvent" && res?.amount == 0) {
            response.data.data.invoiceable.status = "Paid"
            setEventOrder(true)
          }
          setInvoiceDetails(response.data.data);
          setOrders(
            response.data.data.invoiceable
              ? response.data.data.invoiceable.orders
              : []
          );
          setCombos(
            response.data.data.invoiceable
              ? response.data.data.invoiceable.combos
              : []
          );
          // setMetaOrders(response.data.data.invoiceable.meta ? response.data.data.invoiceable.meta  : [])
          if (
            response.data.data.partials &&
            response.data.data.partials.length > 0
          ) {
            setPartialInvoice(response.data.data.partials);
          }
          if (
            response.data.data.status === "Paid" ||
            response.data.data.status === "Failed"
          ) {
            setIsLoading(true);
          }
          let dontShowInvoice = (response?.data?.data?.status == "Direct" && (response?.data?.data?.created_from?.id == 2))  // 2 is for coming from pos systme
          if (dontShowInvoice) {
            setInvoiceFound(false);
          }

          getStore(slug, branchID, branchSlug);
        } else {
          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: false,
          });
          setErrorMessage(response.data.message);
          setInvoiceFound(false);
          setIsLoading(false);
          // history.push("/")
        }
      } catch (e) {
        handleError(e, appDispatch);

        // setAlertMessage({
        //   open: true,
        //   message: e.data.message,
        //   alertSuccess: false,
        // });
        // setErrorMessage(e.data.message);
        setInvoiceFound(false);
        setIsLoading(false);
      }
    }
  };
  const handleAmount = (e) => {
    isNaN(parseFloat(e.target.value))
      ? setAmount()
      : setAmount(parseFloat(e.target.value));
  };

  useEffect(() => {
   

    if (type == "in") {
      orderInvoiceIn();
    }
    if (appState.loggedIn) {
      if (appState.profile) {
        let mobile;
        if (appState.profile.number) {
          let mob = appState.profile.number;
          let sliced = mob.slice(4, 9);
          let st = "*";
          let stArr = [];
          let mobLe = mob.slice(9, mob.length).length;
          for (let i = 0; i < mobLe; i++) {
            st += "*";
          }
          mobile = `***${sliced}${st}`;
        }
      }
    }
  }, [type]);
  useEffect(() => {
    if (!appState.loggedIn) {
      setFormData({
        ...formData,
        name: null,
        email: null,
        number: "",
        country_code: "",
      });
    }
  }, [appState.loggedIn]);
  const AddInfo = () => {
    setAdditionalInfo(!additionalInfo);
  };
  const handleFormChange = (prop) => (e) => {
    if (prop == "number") {
      if (
        (e.target.value.length < 9 || e.nativeEvent.data == null) &&
        e.nativeEvent.data !== ("+" || "-")
      ) {
        setFormData({ ...formData, [prop]: e.target.value });
      }
    } else {
      setFormData({ ...formData, [prop]: e.target.value });
    }
  };

  useEffect(() => {
    localStorage.setItem("fields", JSON.stringify(field));
  }, [field]);

  useEffect(() => {
    if (tapId) {
      payInvoices();
    }
  }, [tapId]);

  useEffect(() => {
    setTimeout(() => {
      setAlertMessage({ open: false, message: "", alertSuccess: false });
    }, 8000);
  }, [alertMessage.open]);

  useEffect(async () => {
    setIsLoading(true);

    if (customer != {}) {
      setFormData({
        ...formData,
        name: customer.name,
        email: customer.email,
        number: customer.number,
        country_code: customer.country_code,
      });
    }
  }, [customer]);

  const handleTryAgain = () => {
    setTryAgain(true);
  };
  const goBackMain = () => {
    removeLocalStorage();
    appDispatch({
      type: "setShareInvoiceQrcode",
      shareInvoiceQrcode: false,
    });

    appDispatch({
      type: "setSplitBill",
      splitBill: false,
    });
    localStorage.removeItem("splitBill");

    appDispatch({
      type: "setPayForItems",
      payForItems: false,
    });
    localStorage.removeItem("payForItems");

    appDispatch({
      type: "setDivideBill",
      divideBill: false,
    });
    localStorage.removeItem("divideBill");

    appDispatch({
      type: "setPayCustomAmount",
      payCustomAmount: false,
    });
    localStorage.removeItem("payCustomAmount");

    appDispatch({
      type: "setShareInvoiceQrcode",
      shareInvoiceQrcode: false,
    });

    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: false,
    });
    localStorage.removeItem("splitBillOptions");
  };

  useEffect(() => {
    if (type === "qp" || type === "in") {
      document.body.style.background = "#f4f4f4";
    }
  }, []);

  const toggleLanguage = () => {
    const nextLang = appState.langValue === "ar" ? "en" : "ar";
    appDispatch({
      type: "LangChange",
      langValue: nextLang,
    });
    if (store?.currencyCode) {
      const nextCurrencyLabel = getCurrencyLabel(store.currencyCode, nextLang);
      const nextStore = { ...store, currency: nextCurrencyLabel };
      setStore(nextStore);
      if (appState.storeInfo?.currencyCode) {
        appDispatch({
          type: "SET_STORE_INFORMATION",
          storeInfo: { ...appState.storeInfo, currency: nextCurrencyLabel },
        });
      }
    }
  };

  const handleProfileClick = () => {
    if (appState.loggedIn) {
      history.push("/dashboard");
      return;
    }
    const shopUrl = window.location.href;
    const authUrl = `${process.env.REACT_APP_AUTH_URL}`;
    setCookie("redirect", shopUrl);
    window.location.replace(authUrl);
  };

  const handleShareClick = async () => {
    const shareData = {
      title: `${store?.business_name || "Invoice"}`,
      text: `Invoice ${invoiceDetails?.id || ""}`.trim(),
      url: window.location.href,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        appDispatch({
          type: "setShareInvoiceQrcode",
          shareInvoiceQrcode: true,
        });
      }
    } catch (e) {
      // user cancelled native share action
    }
  };

  const customerName = appState.loggedIn
    ? appState.profile?.userFirstName || appState.profile?.name || customer?.name || formData?.name
    : customer?.name || formData?.name;
  const customerNumber = appState.loggedIn ? appState.profile?.number || customer?.number || formData?.number : customer?.number || formData?.number;
  const customerEmail = appState.loggedIn ? appState.profile?.email || customer?.email || formData?.email : customer?.email || formData?.email;
  const payableAmount = Number(splitBillAmount) > 0 ? splitBillAmount : amount;

  // useEffect(() => {
  //  console.log("setStore",store)
  //  console.log("invoiceDetail.isReviewed",invoiceDetails.isReviewed)
  // }, [store,invoiceDetails])


  if (isLoading)
    return (
      <div className={`${classes.root} ${classes.height}`}>
        <LoaderAnimation />
      </div>
    );
  const isUnpaidPartial =
    invoiceDetails?.is_partial && !invoiceDetails?.is_paid;

  return invoiceFound ? (
    (invoiceDetails.status == "Paid" ||
      (invoiceDetails.status == "Pending" && invoiceDetails.type !== "QuickInvoice") ||
      invoiceDetails.status == "Cancelled" ||
      invoiceDetails.status == "Direct" ||
      invoiceDetails.status == "Failed" ||
      invoiceDetails.is_paid || eventOrder || ((hasDelivery || hasPickup) && (invoiceDetails.status == "Paid" || invoiceDetails.status == "Pending" )  )) &&
      !isUnpaidPartial &&
      tryAgain == false ? (
      showPartialInvoice ? (
        <PartialInvoice
          storeInfo={store}
          invoiceDetail={invoiceDetails}
          handleTryAgain={handleTryAgain}
        />
      ) : (
        <Invoice 
        storeInfo={store}
        invoiceDetail={invoiceDetails}
        eventOrder={eventOrder}
        amount={payableAmount}
        handleTryAgain={handleTryAgain}
        languageLabel={appState.langValue === "ar" ? "English" : "عربي"}
        toggleLanguage={toggleLanguage}
        handleProfileClick={handleProfileClick}
        onShareClick={handleShareClick}
        addsInfo={addsInfo}
        
        />

      )
    ) : (
      <>
        {" "}
        {appState.freezScreen && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={appState.freezScreen}
          >
            <LoaderAnimation />
          </Backdrop>
        )}
        <Backdrop
          onClick={goBackMain}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={
            appState.splitBillOptions ||
            appState.payForItems ||
            appState.divideBill ||
            appState.payCustomAmount
            ||
            appState.shareInvoiceQrcode
          }
        ></Backdrop>

        {type === "in" && !invoiceDetails?.is_partial ? (
          <RestaurantInvoicePaymentOneScreen
            languageLabel={appState.langValue === "ar" ? "English" : "عربي"}
            onLanguageToggle={toggleLanguage}
            onProfileClick={handleProfileClick}
            onShareClick={handleShareClick}
            onLogoutClick={() => appDispatch({ type: "logout" })}
            store={store}
            logo={store?.logo}
            restaurantName={store?.business_name || "-"}
            branchName={store?.branch_name || ""}
            invoiceNumber={invoiceDetails?.id || ""}
            // invoiceDescription={invoiceDetails?.description || `This invoice covers your order at ${store?.business_name || "the restaurant"}.`}
            amount={payableAmount}
            currency={getCurrencyLabel(store?.currencyCode, appState.langValue)}
            customerName={customerName}
            customerNumber={customerNumber}
            customerEmail={customerEmail}
            cardElement={
              <GoSellElementsTrans
                live={store?.live}
                tapkey={store?.key}
                status={"invoice"}
                ref={childRef}
                inpValue={payableAmount}
                currency={store?.currencyCode}
                tapId={tapId}
                setTapId={setTapId}
                payWithValue={payWithValue}
                setButtonLoading={setButtonLoading}
                setTapCardDetails={setTapCardDetails}
                setAlertMessage={setAlertMessage}
              />
            }
            tapId={tapId}
            onConfirmPay={handleSubmit}
            onApplePay={handleClickApplePay}
            loading={buttonLoading}
            selectedPayment={payWithValue}
            onPaymentChange={handlePaymentChange}
          />
        ) : (
        <section
          id="payments"
          className={` bgf4f4f4 ${appState.langValue === "ar" ? "directionRtl" : ""
            } ${pLoading ? "disableClass" : ""
            } d-flex flex-column justify-content-center`}
        >
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alertMessage.open}
            className={
              alertMessage.alertSuccess ? "success-alert" : "danger-alert"
            }
          >
            {alertMessage.alertSuccess ? (
              <Alert severity="success">{alertMessage.message}</Alert>
            ) : (
              <Alert severity="error">{alertMessage.message}</Alert>
            )}
          </Snackbar>
          <div className="container ">
            <div className="row d-flex justify-content-center">
              <div
                className={`bg-white ${appState.loggedIn && appState.cardList.length > 1
                    ? ""
                    : "vh-100"
                  } col-md-6  p-0`}
              >
                {/* banner */}
                <div className="container ">
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12  p-0">
                      {type === "in" &&
                        invoiceDetails?.is_partial &&
                        invoiceDetails.is_paid == false ? (
                        <MiscBannerv2
                          store={store}
                          amount={amount}
                          handleAmount={handleAmount}
                          invoiceDetails={invoiceDetails}
                          type={type}
                          cover={store.cover}
                        />
                      ) : (
                        <MiscBannerv3
                          store={store}
                          amount={amount}
                          handleAmount={handleAmount}
                          invoiceDetails={invoiceDetails}
                          type={type}
                          cover={store.cover}
                        />
                      )}
                      {/* here its updated */}
                    </div>
                  </div>
                </div>

                {type === "in" &&
                  invoiceDetails?.is_partial &&
                  invoiceDetails.is_paid == false && (
                    <SplitBillDetails
                      splitBillAmount={splitBillAmount}
                      setSplitBillAmount={setSplitBillAmount}
                      orders={orders}
                      combos={combos}
                      paidAmount={invoiceDetails.amount}
                      subTotal={amount}
                      partialType={partialType}
                      setPartialType={setPartialType}
                      setPayWithValue={setPayWithValue}
                      goBackMain={goBackMain}
                    />
                  )}

                {appState.splitBill && (
                  <>
                    <div className="container InvoiceInputParent">
                      <div className="row d-flex justify-content-center">
                        <div className="col-md-12 bg-white ">
                          <div
                            className={
                              type === "in"
                                ? "container-div px-0 invoice-store"
                                : "container-div px-0"
                            }
                          >
                            <main>
                              {/*  */}
                              <Payments
                                store={store}
                                handlePaymentChange={handlePaymentChange}
                                payWithValue={payWithValue}
                                paymentSource={paymentSource}
                                childRef={childRef}
                                amount={Number(amount)}
                                setButtonLoading={setButtonLoading}
                                setTapId={setTapId}
                                setTapCardDetails={setTapCardDetails}
                                setAlertMessage={setAlertMessage}
                                t={t}
                                type={type}
                                handleClickApplePay={handleClickApplePay}
                                storeBranchId={storeBranchId}
                              />
                            </main>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`${appState.loggedIn && appState.cardList.length > 1
                          ? "bottom-0"
                          : ""
                        } container confirmpayStickyMain bg-white`}
                    >
                      <div className="row  d-flex justify-content-center">
                        <div className="col-md-12 w-100   pb-1">
                          {invoiceDetails ? (
                            invoiceDetails.status === "Paid" ? (
                              ""
                            ) : (
                              <div className="text-center">
                                <div className={classes.root}>
                                  <div
                                    className={`${appState.loggedIn &&
                                        appState.cardList.length > 1
                                        ? "mt-4"
                                        : ""
                                      } ${classes.wrapper}`}
                                  >
                                    <Button
                                      variant="contained"
                                      disabled={buttonLoading}
                                      onClick={handleSubmit}
                                      className={`col-12 bg-btn payBtn py-3 d-flex align-items-center justify-content-between ${payWithValue == '' && `disabledBtn`} `}
                                    >
                                      <span>{t("invoice.pay")}</span>
                                      <span>
                                        {" "}
                                        {buttonLoading ? "Processing" : ""}{" "}
                                      </span>
                                      <span>
                                        {" "}
                                        {formatMoney(
                                          splitBillAmount,
                                          store?.currencyCode,
                                          appState.langValue
                                        )}{" "}
                                      </span>
                                    </Button>
                                    {buttonLoading && (
                                      <CircularProgress
                                        size={24}
                                        className={classes.buttonProgress}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            )
                          ) : (
                            <div className="text-center">
                              <div className={classes.root}>
                                <div className={` ${classes.wrapper}`}>
                                  <Button
                                    variant="contained"
                                    disabled={buttonLoading}
                                    onClick={handleSubmit}
                                    className={`col-12 bg-btn py-3 payBtn d-flex align-items-center justify-content-between ${payWithValue == '' && `disabledBtn`}`}
                                  >
                                    <span> {t("invoice.pay")}</span>
                                    <span>
                                      {" "}
                                      {buttonLoading ? "Processing" : ""}{" "}
                                    </span>
                                    <span>
                                      {" "}
                                      {formatMoney(
                                        splitBillAmount,
                                        store?.currencyCode,
                                        appState.langValue
                                      )}{" "}
                                    </span>
                                  </Button>
                                  {buttonLoading && (
                                    <CircularProgress
                                      size={24}
                                      className={classes.buttonProgress}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {appState.splitBillOptions && <SplitBillOptions />}
                {false && (
                  // appState.payForItems
                  <PayForItems
                  // .store?.currency
                    store={store}
                    orders={orders}
                    subTotal={amount}
                    paidAmount={invoiceDetails.amount}
                    paySelectedItems={paySelectedItems}
                    setPaySelectedItems={setPaySelectedItems}
                    setPartialType={setPartialType}
                    splitBillAmount={splitBillAmount}
                    setSplitBillAmount={setSplitBillAmount}
                    partialInvoice={partialInvoice}
                  />
                )}
                {appState.divideBill && (
                  <DivideBill
                  store={store}
                    subTotal={amount}
                    paidAmount={invoiceDetails.amount}
                    setPartialType={setPartialType}
                    splitBillAmount={splitBillAmount}
                    setSplitBillAmount={setSplitBillAmount}
                    totalPerson={totalPerson}
                    setTotalPerson={setTotalPerson}
                    personWillPay={personWillPay}
                    setPersonWillPay={setPersonWillPay}
                  />
                )}
                {appState.payCustomAmount && (
                  <PayCustomAmount
                  store={store}
                    subTotal={amount}
                    paidAmount={invoiceDetails.amount}
                    setPartialType={setPartialType}
                    splitBillAmount={splitBillAmount}
                    setSplitBillAmount={setSplitBillAmount}
                    payInvoices={payInvoices}
                  />
                )}
                {appState.shareInvoiceQrcode && (
                  <ShareInvoiceQrcode
                  store={store}
                  type={type}
                    invoiceDetails={invoiceDetails}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
        )}
      </>
    )
  ) : (
    <NotFound id={id} errorMessage={errorMessage} />
  );
};

const Payments = (props) => {
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);
  const [isLoading, setIsLoading] = useState("");
  const [open, setOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("wallet");
  const [seeMore, setSeeMore] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [allSavedCards, setAllSavedCards] = useState(false);
  const { t, type, storeBranchId } = props;
  const [showAppleBtn, setShowAppleBtn] = useState(false);
  useEffect(() => {
    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      setShowAppleBtn(true);
    }
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleClickLogin = () => {
    var shop_url = window.location.href;
    var auth_url = `${process.env.REACT_APP_AUTH_URL}`;
    setCookie(`redirect`, shop_url);
    window.location.replace(auth_url);
  };
  const handlChangeView = () => {
    setSeeMore(appState.cardList.length);
  };
  const handleCloseLogin = () => {
    setOpenModal(false);
  };
  const showAllSavedCards = () => {
    setAllSavedCards(!allSavedCards);
  };

  const handleTabChange = (event, newValue) => {
    if (newValue) {
      props.handlePaymentChange(newValue);
      setPaymentMethod(newValue);
    }
  };

  const payments = appState?.acceptedPayments || [];
  const tapStatus = !props.store.tap;
  const campaignDiscount = props.campaignDiscount || 0;

  return (
    <>
      <div>
        <CustomizedDialogs
          open={open}
          handleClose={handleClose}
          setAlertMessage={props.setAlertMessage}
        />

        {/* <LoginModal closeBtn={true} /> */}

        {appState.loggedIn && appState.cardList.length > 0 ? (
          <div className="container-fluid px-0 payWith saveCardsParent">
            <div className="row mx-0">
              <div className="col px-0 d-flex  align-items-center py-2">
                <p className="mb-0 AddOptionalInfo">
                  {t("invoice.Use-Saved-Cards")}
                </p>
              </div>
            </div>
            {appState?.acceptedPayments
              ? (appState?.acceptedPayments.includes("save_card") && storeBranchId != 110)
                ? appState.loggedIn
                  ? appState.cardList != null
                    ? appState.cardList.slice(0, seeMore).map((val, ind) => {
                      return (
                        <div
                          onClick={() => props.handlePaymentChange(val.id)}
                          className={`col-12 p-0  ${props.amount <= 0 ? `disabledBtn` : ``
                            } `}
                          key={ind}
                        >
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              checked={props.payWithValue == val.id}
                              value={val.id}
                              name="paymentMethod"
                              className={
                                props.amount <= 0 ? `disabledBtn` : ``
                              }
                              id={`paymentSaveCard-${val.id}`}
                              disabled={!props.store.tap}
                            />
                            <label
                              htmlFor={`paymentSaveCard-${val.id}`}
                              disabled={!props.store.tap}
                            >
                              <div
                                className={`payment-method py-3 ${props.amount <= 0 ? `disabledBtn` : ``
                                  }`}
                              >
                                <span className="px-4">
                                  <img
                                    src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                                    alt=""
                                    width="30"
                                  />
                                </span>
                                <span
                                  className={`px-4 saveCardsBtn ${appState.langValue === "ar"
                                      ? "saveCardsBtnrtl"
                                      : ""
                                    }`}
                                >
                                  <h4 className="cardNumber ">
                                    **** **** **** {val.last_four}
                                  </h4>
                                  {seeMore == 1 ? (
                                    <Button
                                      className="cardName mb-0 px-0 "
                                      onClick={handlChangeView}
                                    >
                                      <span className="px-2">
                                        {appState.langValue === "ar" ? (
                                          <ArrowForwardIosIcon />
                                        ) : (
                                          <ArrowBackIosIcon />
                                        )}{" "}
                                      </span>
                                      {t("invoice.Choose-another")}{" "}
                                    </Button>
                                  ) : (
                                    <Button className="cardName mb-0 px-0">
                                      {t("invoice.Use-this-Card")}{" "}
                                      <span className="px-2">
                                        {appState.langValue === "ar" ? (
                                          <ArrowBackIosIcon />
                                        ) : (
                                          <ArrowForwardIosIcon />
                                        )}
                                      </span>
                                    </Button>
                                  )}
                                </span>
                              </div>
                            </label>
                          </div>
                        </div>
                      );
                    })
                    : ""
                  : ""
                : ""
              : ""}

            {/* <div className="row">
    <div className="col px-0 d-flex justify-content-between align-items-center">
      <p className="mb-0 AddOptionalInfo">All Saved Cards</p>
      <div onClick={showAllSavedCards}>
        {allSavedCards ? (
          <Button>
            <span className="text-blue-payment">-</span>
          </Button>

        ) : (
          <Button>
            <span className="text-blue-payment"> +</span>
          </Button>

        )}
      </div>

    </div>
  </div> */}
          </div>
        ) : (
          ""
        )}

        <div
          className={`${appState.loggedIn && appState.cardList.length > 1 ? "pb-5 mb-3" : ""
            } `}
        >
          <div className="paymentMethod mt-3 tabNavigation">
            <h5
              className={`familyManrope700 py-2   payWith ${appState.langValue === "ar" ? "text-right" : "text-left"
                }`}
            >
              {t("invoice.Pay-With")} :
            </h5>
            {appState?.acceptedPayments !== undefined && (
              <>
                  {/* {(false) ? ( */}
                {(appState?.acceptedPayments.includes("apple_pay") && props.store.tap && showAppleBtn && storeBranchId != 110) ? (
                  <div>
                    <ApplePayBtn
                      handleClickApplePay={props.handleClickApplePay}
                    />
                    <p className="text-center divider familyPoppins600 mb-0 py-3 text-capitalize ">
                      <span>
                        {" "}
                        <div className="circleDiv d-flex justify-content-center align-items-center">
                          {t("login.OR")}
                        </div>{" "}
                      </span>
                    </p>
                  </div>
                ) : (
                  ""
                )}


                <Tabs 
                  value={paymentMethod} 
                  onChange={handleTabChange}
                  className="tabListCustomized d-flex justify-content-evenly align-items-center"
                  sx={{
                    '& .MuiTabs-flexContainer': {
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'evenly',
                    },
                    '& .MuiTab-root': {
                      flexDirection: 'column',
                      minHeight: 'auto',
                      padding: '12px',
                    }
                  }}
                >
                  {/* {payments.includes("wallet") && storeBranchId != 110 && (
                    <Tab
                      className="customTabs"
                      disabled={tapStatus}
                      value="wallet"
                      label={
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img className="mb-1" src={vendorsConfig.APP_ICON} alt={vendorsConfig.APP_NAME} style={{ display: 'block' }} />
                          <p className="m-0">{t("pay.wallet")}</p>
                        </div>
                      }
                    />
                  )} */}
                  {payments.includes("knet") && (
                    <Tab
                      className={`customTabs w-50 ${paymentMethod == 'knet' ? `base--selected` : ''} `}
                      style={{ boxShadow: 'none !important' }}
                      value="knet"
                      label={
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <img className="mb-1" src={knetsm} alt="knet" style={{ display: 'block' }} />
                          <p className="m-0">{t("pay.knet")}</p>
                        </div>
                      }
                    />
                  )}
                  {payments.includes("card") && storeBranchId != 110 && (
                    <Tab
                      className={`customTabs w-50 ${paymentMethod == 'card' ? `base--selected` : ''} `}
                      style={{ boxShadow: 'none !important' }}
                      value="card"
                      disabled={tapStatus || appState.storeInfo.tapKey === null}
                      label={
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <img className="mb-1" src={masterVisa} alt="credit" style={{ display: 'block' }} />
                          <p className="m-0">{t("pay.creadit")}</p>
                        </div>
                      }
                    />
                  )}
                  {!appState.splitBill
                    ? payments.includes("cashables") && (
                      <Tab 
                        className={`customTabs ${paymentMethod == 'cash' ? `base--selected` : ''} `}
                        value="cash"
                        disabled={campaignDiscount > 0}
                        label={
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img className="mb-1" src={simpleCash} alt="cash" style={{ display: 'block' }} />
                            <p className="m-0">{appState.deliveryMode ? t("pay.cash") : t("In Store")}</p>
                          </div>
                        }
                      />
                    )
                    : ""}
                </Tabs>
              </>
              
            )}
          </div>
          <section className="payWith row mt-3">
            {props.payWithValue == "card" ? (
              <div className="col-12  px-0 d-flex align-items-center justify-content-center">
                <GoSellElementsTrans
                  live={props.store.live}
                  tapkey={props.store.key}
                  status={"invoice"}
                  ref={props.childRef}
                  inpValue={props.amount}
                  currency={props.store?.currencyCode}
                  setTapId={props.setTapId}
                  setTapCardDetails={props.setTapCardDetails}
                  payWithValue={props.payWithValue}
                  setButtonLoading={props.setButtonLoading}
                  setAlertMessage={props.setAlertMessage}
                />
              </div>
            ) : (
              ""
            )}
          </section>
        </div>
      </div>
    </>
  );
};

export default withTranslation()(Payment);
